import { gcd } from './math.js';
function parse(ratio) {
    const matches = /(\d+)\s*[x/]\s*(\d+)/.exec(ratio);
    if (!matches)
        throw new Error(`${ratio} does not contain a valid ratio`);
    const w = parseInt(matches[1], 10);
    const h = parseInt(matches[2], 10);
    return aspectRatio(w, h);
}
export { parse as parseAspectRatio };
export function aspectRatio(ratioWidth, ratioHeight) {
    const relation = ratioWidth / ratioHeight;
    const divisor = gcd(ratioWidth, ratioHeight);
    const ratio = [ratioWidth / divisor, ratioHeight / divisor];
    return {
        getWidth(height) {
            return Math.floor(height * relation);
        },
        getHeight(width) {
            return Math.floor(width / relation);
        },
        getRelation() {
            return relation;
        },
        equals(aspectRatio) {
            const ratio = typeof aspectRatio === 'string' ? parse(aspectRatio) : aspectRatio;
            return relation === ratio.getRelation();
        },
        toString() {
            return ratio.join('x');
        },
        join(s = 'x') {
            return ratio.join(s);
        },
    };
}
export const aspectRatio16x9 = aspectRatio(16, 9);
export const aspectRatio4x3 = aspectRatio(4, 3);
export const aspectRatio3x4 = aspectRatio(3, 4);
export const aspectRatio2x3 = aspectRatio(2, 3);
